import React from "react";
import "./styles.scss";

const Skeleton = ({ width = "100%", ml, mr }) => (
  <span
    className="skeleton"
    style={{
      width: isNaN(width) ? width : `${width}px`,
      marginLeft: isNaN(ml) ? ml : `${ml}px`,
      marginRight: isNaN(mr) ? mr : `${mr}px`
    }}
  >
    &nbsp;
  </span>
);

export default Skeleton;
